module.exports = __webpack_public_path__ + "static/media/stripe-onboarding_2.1d787190.png";